import { FieldLeadLayout } from "@/screens/fieldLead/FieldLeadLayout";
import { FieldLeadScreen } from "@/screens/fieldLead/FieldLeadScreen";
import { LoginScreen } from "@/screens/login/LoginScreen";
import { ProfileScreen } from "@/screens/profile/ProfileScreen";
import { ShellError, ShellLoading } from "@/screens/shell/ShellStates";
import { Navigate, type RouteObject, useLocation } from "react-router-dom";
import { AccountGate } from "./accountGate";
import { useAuth } from "./auth";
import { FIELD_LEAD_PATH } from "./navigation";
import { SessionProvider } from "./session";

function ProtectedShell() {
  const { token } = useAuth();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return (
    <SessionProvider
      renderLoading={() => <ShellLoading />}
      renderError={(message, retry) => <ShellError message={message} onRetry={retry} />}
    >
      <AccountGate>
        <FieldLeadLayout />
      </AccountGate>
    </SessionProvider>
  );
}

function LoginRoute() {
  const { token } = useAuth();
  const location = useLocation();
  const from =
    typeof location.state === "object" && location.state !== null
      ? (location.state as { from?: unknown }).from
      : undefined;

  if (token) {
    return <Navigate to={typeof from === "string" ? from : "/"} replace />;
  }

  return <LoginScreen />;
}

const shellChildren: RouteObject[] = [
  { index: true, element: <Navigate to={FIELD_LEAD_PATH} replace /> },
  { path: "field-lead", element: <FieldLeadScreen /> },
  { path: "preferences", element: <ProfileScreen /> },
  { path: "*", element: <Navigate to={FIELD_LEAD_PATH} replace /> },
];

export const appRoutes: RouteObject[] = [
  { path: "/login", element: <LoginRoute /> },
  { path: "/", element: <ProtectedShell />, children: shellChildren },
];
